export default __webpack_public_path__ + "static/media/javascript.86554095.svg";